import type { StoreDispatch } from '@app/store/dispatch'
import type { ThunkAction } from '@app/store/thunk'
import { createThunk } from '@app/store/thunk'

export const withTransaction = <P>(action: ThunkAction<P>) =>
  createThunk(async (dispatch, getState, context) => {
    const reducer = dispatch(getMainReducer())
    const actions: any[] = []
    let state = getState()
    const gs = () => state
    const pdispatch: StoreDispatch = (action: any) => {
      if (typeof action === 'function') {
        return action(pdispatch, gs, context)
      }
      state = reducer(state, action)
      actions.push(action)
      return action
    }
    const result = await action(pdispatch, gs, context)
    const commit = () => {
      for (const action of actions) {
        dispatch(action)
      }
    }
    return { result, commit }
  })

export const setMainReducer = (r: (state: any, action: any) => any) =>
  createThunk((_dispatch, _getState, context) => {
    context.getRootContext().set(ReducerSymbol, r)
  })

export const getMainReducer = () =>
  createThunk((_dispatch, _getState, context) => {
    return context.getRootContext().getEnsure<(state: any, action: any) => any>(ReducerSymbol)
  })

const ReducerSymbol = Symbol('REDUCER_SYMBOL')
